export const transformToKeys = obj => {
  const result = {};

  for (const [key, value] of Object.entries(obj)) {
    if (Array.isArray(value)) {
      // If it's an array of objects with 'key' property, extract the keys
      if (value.length > 0 && typeof value[0] === 'object' && value[0].key) {
        result[key] = value.map(item => item.key);
      } else if (value.length > 0) {
        // If it's an array of non-objects, just use the array as is
        result[key] = value;
      }
      // Skip empty arrays - don't add them to result
    } else {
      // For non-array values (like strings), only add if not empty
      if (value !== '' && value !== null && value !== undefined) {
        result[key] = value;
      }
    }
  }

  return result;
};
